import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export type CriticalIllnessProductBackend = {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: any;
  dateOfBirth: string;
  insuredSum: number;
  isFemale: boolean;
  isScandinavianCitizen: boolean;
  isSmoker: boolean;
  isStayingInNorwayForMoreThanFiveYears: boolean;
};

export function mapToCommerceCriticalIllness(data: {
  [key: string]: any;
}): CriticalIllnessProductBackend {
  return {
    name: INSURANCE_NAME_VALUE.CRITICAL_ILLNESS,
    coverageGroup: data.coverage,
    dateOfBirth: data.customerData.newCustomerResponse.dateOfBirth,
    insuredSum: data.insuredSum,
    isFemale: data.customerData.newCustomerResponse.isFemale,
    isScandinavianCitizen: true,
    isSmoker: false,
    isStayingInNorwayForMoreThanFiveYears: true,
  };
}
